import {
    GameIntroColors,
    GameIntroViewConfig, StampConfig, Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {CustomSlideShowPage} from "./custom/CustomSlideShowPage";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";


export class XwaysHoarder2IntroConfig implements GameIntroViewConfig {

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];
    stampConfig:StampConfig = {
        xWays:true,
        xBet: true,
        xSplit: true,
        volatility:Volatility.EXTREME
    };

    colors:GameIntroColors = {
        slideShowColors:{
            backgroundColor:0x000000, //Default 0x000000
            backgroundAlpha:0.4, //Default 0.4
            bulletColor:0xffffff, //Default 0xffffff

        },
        stampColor:0xFFFFFF
    };

    init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("feature1", "resources/images/intro_feature1.png");
        imgLoader.add("feature2", "resources/images/intro_feature2.png");

        imgLoader.add("feature3", "resources/images/Intro_Feature_1.png");
        //imgLoader.add("feature4", "resources/images/Intro_Feature_2.png");
        imgLoader.add("feature5", "resources/images/defaultFeature.png");
        imgLoader.add("logo", "resources/images/introLogo.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics(){
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();

        this.borderBottom = new PIXI.Container();

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);

        this.pages = [
            new CustomSlideShowPage(ImgLoader.getImgTexture("feature1")),
            new CustomSlideShowPage(ImgLoader.getImgTexture("feature2")),
            new CustomSlideShowPage(ImgLoader.getImgTexture("feature3")),
            new CustomSlideShowPage(ImgLoader.getImgTexture("feature5"))
        ];

        this.borderBottom.visible = false;
        this.borderTop.visible = false;
    }


    onClose() {
        XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.START_GAME);
    }

}